import { useEffect, useState } from "react";
import { useAuth } from "../useAuth";

export default () => {
  const {
    user,
    business,
    selectedBusiness,
    admin,
    isAdmin,
    updateAdminUser,
    addUserByAdmin,
    updateCurrentUser,
  } = useAuth();
  const [userLoading, setUserLoading] = useState(false);
  const [aclData, setAclData] = useState();

  const [users, setUsers] = useState([]);

  const allBusinesses =
    isAdmin && admin?.businesses
      ? admin.businesses?.map((x) => {
          const found = business?.find((el) => el.id === x.id);
          if (found) {
            return { ...x, reportsettings: found.business?.reportsettings };
          }
          return x;
        })
      : business?.map((x) => ({
          ...x,
          reportsettings: x.business?.reportsettings,
          name: x.business?.name,
          status: x.business?.status,
        }));

  useEffect(
    () => () => {
      setUsers([]);
    },
    [user?.id]
  );

  // const usersNew =
  //   isAdmin && admin.users
  //     ? admin.users.map((x) => ({
  //         ...x,
  //         businesslist:
  //           typeof x.businesslist === "string"
  //             ? JSON.parse(x.businesslist)
  //             : x.businesslist,
  //       }))
  //     : users;

  return {
    userLoading,
    aclData,
    setAclData,
    setUserLoading,
    user,
    users,
    setUsers,
    business,
    selectedBusiness,
    admin,
    isAdmin,
    updateAdminUser,
    addUserByAdmin,
    allBusinesses,
    updateCurrentUser,
  };
};
